export default [
    {
        'text': 'Johor',
        'value': 'Johor'
    },
    {
        'text': 'Kedah',
        'value': 'Kedah'
    },
    {
        'text': 'Kelantan',
        'value': 'Kelantan'
    },
    {
        'text': 'Melaka',
        'value': 'Melaka'
    },
    {
        'text': 'Negeri Sembilan',
        'value': 'Negeri Sembilan'
    },
    {
        'text': 'Pahang',
        'value': 'Pahang'
    },
    {
        'text': 'Perak',
        'value': 'Perak'
    },
    {
        'text': 'Perlis',
        'value': 'Perlis'
    },
    {
        'text': 'Pulau Pinang',
        'value': 'Pulau Pinang'
    },
    {
        'text': 'Sabah',
        'value': 'Sabah'
    },
    {
        'text': 'Sarawak',
        'value': 'Sarawak'
    },
    {
        'text': 'Selangor',
        'value': 'Selangor'
    },
    {
        'text': 'Terengganu',
        'value': 'Terengganu'
    },
    {
        'text': 'W.Persekutuan (KL)',
        'value': 'W.Persekutuan (KL)'
    },
    {
        'text': 'W.Persekutuan (LABUAN)',
        'value': 'W.Persekutuan (LABUAN)'
    },
    {
        'text': 'W.Persekutuan (PUTRAJAYA)',
        'value': 'W.Persekutuan (PUTRAJAYA)'
    }
];
